import React from "react";
import BusinessListingPage from "../../components/BusinessListingPage";
import { _get_discovery_trending } from "../../common/axios_services";
import { storePromoImages } from "../../common/promoConfig";

const RawFood = () => {
  return (
    <BusinessListingPage
      title=""
      bannerText="WHOLESALE ITEMS"
      businessType="raw_food"
      fetchBusinessesApi={_get_discovery_trending}
      promoImages={storePromoImages}
    />
  );
};

export default RawFood;
